
import { mapGetters } from 'vuex'
import { name as toName } from '~/util/string'

export default {
    props: {
        summary: {
            type: Object,
            default: null
        },
        client: {
            type: Object,
            default: null
        },
    },
    data () {
        return {
            form: {
                to: this.client?.email || '',
                subject: `${this.$store.getters.canAgent ? this.$store.getters.summaryAep ? `AEP Recommendation: ${toName(this.client, { skipPreferred: true })}` : `Medicare Overview: ${toName(this.client, { skipPreferred: true })}` : `${toName(this.client, { skipPreferred: true })}'s ` + (this.$store.getters.summaryAep ? `AEP Plan Summary ${this.$store.getters.year}` : `Medicare Overview for ${this.summary.year}`)}`,
                light: true,
                message: `
                        <p>Dear ${this.$_.startCase(this.client.preferred_name || this.client.first_name)},</p>

                        ${this.$store.getters.summaryAep
        ? `<p>Thank you for providing us with your updated prescription and health information! I want to pass along our plan analysis for ${this.$store.getters.year} (attached below).</p>`
        : this.$store.getters.canAgent
            ? '<p>It was wonderful speaking with you today! I would like to follow up after our consultation and provide you with the following documents (attached):</p>'
            : '<p>We would like to follow up our online consultation and provide you with the following documents (attached):</p>'
}
            ${!this.$store.getters.summaryAep
        ? `<ul>
                            <li>Medicare Consultation Summary</li>
                            <li>Plan Benefit Brochures</li>
                        </ul>`
        : ''
}

                        <p>
                            Please don't hesitate to reach out if you have any questions. ${new Date().getDay() < 5 ? 'Hope you have a wonderful rest of your week!' : 'Hope you have a wonderful weekend!'}
                        <br>
                        <p>
                            <span>${this.$store.getters.canAgent ? toName(this.$store.getters.user, { skipPreferred: true }) : 'The Doctor\'s Choice Team'}</span>
                            </br>
                            <span>Office: <a target="_blank" rel="noopener noreferrer nofollow" href="tel:+14014047373">401-404-7373</a></span>
                            </br>                          
                            <span>Email: <a target="_blank" rel="noopener noreferrer nofollow" href="mailto:${this.$store.getters.canAgent ? this.$store.getters.user.email : 'support@doctorschoiceusa.com'}">${this.$store.getters.canAgent ? this.$store.getters.user.email : 'support@doctorschoiceusa.com'}</a></span>
                        </p>
                `
            },
        }
    },
    computed: {
        ...mapGetters(['summaryAep', 'summaryPlansList']),
        emails () {
            return (this.form.to || '').split(',').map(to => to.trim()).filter(to => !!to)
        },
        possibleNonDownloadableFilesPlans () {
            return this.summaryPlansList.filter(plan => /humana/i.test(plan.carrier) || /humana/i.test(plan.name))
        }
    },
    methods: {
        async send () {
            const { error } = await this.$try('sendSummary', {
                id: this.summary.id,
                data: {
                    ...this.form,
                    to: this.emails
                }
            })
            if (!error) {
                this.$success(`Summary ${this.canAgent ? this.summary.id + ' ' : ' '}sent!`)
                this.$emit('success')
            }
        }
    },
}
